/** @format */
import Messages from "../library/Messages";

export default class FormsValidation {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new FormsValidation();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on("change", ".js-validate-emails-one-per-line", function () {
			self.validateTextAreaEmailsOnePerLine($(this));
		});
	}

	validateTextAreaEmailsOnePerLine($textarea) {
		if (!$textarea.length) return;

		const lines = $textarea.val().trim().split("\n");
		const invalidEmails = this.getInvalidEmailsFromLines(lines);

		if (invalidEmails.length > 0) {
			Messages.error(
				"The following line(s) must contain one valid email per line:\n\n" +
					invalidEmails.join("\n")
			);

			$textarea.addClass("is-erroneous").focus();
			return false;
		}

		$textarea.removeClass("is-erroneous");
		return true;
	}

	getInvalidEmailsFromLines(lines) {
		const invalidEmails = [];

		for (let line of lines) {
			const trimmed = line.trim();
			if (!trimmed) continue;

			// Error if a comma is present in the line
			if (trimmed.includes(",")) {
				invalidEmails.push(trimmed);
				continue;
			}

			if (this.hasMultipleEmailsOnLine(trimmed) || !this.isValidEmail(trimmed)) {
				invalidEmails.push(trimmed);
			}
		}

		return invalidEmails;
	}

	isValidEmail(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	hasMultipleEmailsOnLine(line) {
		// Split by common separators to detect multiple emails
		return line.split(/[\s,;]/).filter(Boolean).length > 1;
	}
}
